export const CART_ACTION = {
  ADD_TO_CART: "CART_ACTION/ADD_TO_CART",
  UPDATE_CART_ITEM: "CART_ACTION/UPDATE_CART_ITEM",
  REMOVE_CART_ITEM: "CART_ACTION/REMOVE_CART_ITEM",
  CLEAR_CART_ITEM: "CART_ACTION/CLEAR_CART_ITEM",
  SET_CHECKOUT_INFO_DATA: "CART_ACTION/SET_CHECKOUT_INFO_DATA",
  SET_COUPON_DATA: "CART_ACTION/SET_COUPON_DATA",
  SET_PAYMENT_DATA: "CART_ACTION/SET_PAYMENT_DATA",
};
